<div class="cmps-cdk-font-size-18p cmps-cdk-text-center">
    <span [innerHTML]="_html"></span>
</div>
